import { useEffect, useState } from "react";
import { isUpdateAvailable, isUpdateRequired, subscribeUpdate } from "../../util/appUpdate.ts";
import s from "./updateBanner.module.scss";

/**
 * Non-modal banner shown when a newer build is detected (version poll) or a lazy chunk
 * failed to load after a deploy (vite:preloadError). The user chooses when to reload — we
 * never auto-reload, so unsaved work isn't clobbered. A chunk-load failure marks the update
 * "required" (the current view can't render): the message firms up and "Later" is hidden.
 */
export function UpdateBanner() {
  const [visible, setVisible] = useState(isUpdateAvailable());
  const [dismissed, setDismissed] = useState(false);

  useEffect(() =>
    subscribeUpdate(() => {
      setVisible(true);
      setDismissed(false); // re-surface even if previously dismissed (e.g. soft → required)
    }),
  []);

  if (!visible || dismissed) return null;
  const required = isUpdateRequired();

  return (
    <div className={`${s.banner} ${required ? s.required : ""}`} role="alert">
      <span className={s.icon} aria-hidden>↻</span>
      <span className={s.msg}>
        {required
          ? "This page needs the latest version. Reload to continue."
          : "A new version of the admin is available."}
      </span>
      <button className={s.reload} onClick={() => window.location.reload()}>Reload now</button>
      {!required && (
        <button className={s.later} onClick={() => setDismissed(true)}>Later</button>
      )}
    </div>
  );
}
